import * as Yup from 'yup'

import { customerContactsValidation } from 'modules/customers/constants/validationSchema'

export const validationSchema = Yup.object(customerContactsValidation)
